module.exports = __webpack_public_path__ + "mm.2d5471c3660b9d73ab18.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mm.svg
// module chunks = styles